import { useMutation, useQueryClient } from '@tanstack/react-query'

import { courseDetailsKeys } from '@/course-generic/queries/queryKeys'
import { polls, pollsQueries } from '@/http/api/polls'

export function usePollResultsCreate() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: polls.results.create,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: pollsQueries.details() })
      await queryClient.invalidateQueries({ queryKey: courseDetailsKeys.all })
    },
  })
}
